export default "__VITE_ASSET__CLA6gbF0__"